(function() {
  "use strict";
  angular.module("marketPlace.profile", ["marketPlace.preview"]);
})();
